module.exports = __webpack_public_path__ + "static/media/play-white.88b17b86.svg";